import { BuyPopupProps } from '@/components/mobile/BuyPopup'
import { ContactPopupProps } from '@/components/mobile/ContactPopup'
import { LoginDialogProps } from '@/components/mobile/LoginDialog/LoginDialog'
import { PayingPopupProps } from '@/components/mobile/PayingPopup'
import { PaySuccessPopupProps } from '@/components/mobile/PaySuccessPopup'
import { action, makeObservable, observable, runInAction } from 'mobx'
import eruda from 'eruda'
import { commonUtils } from '@/helpers/commonUtils'
import { LoginModalProps } from '@/components/pc/LoginModal/LoginModal'
import { PaySuccessModalProps } from '@/components/pc/PaySuccessModal/PaySuccessModal'
import { PayModalProps } from '@/components/pc/PayModal/PayModal'
import { DownloadDialogProps } from '@/components/pc/DownloadDialog'
import emitter, { MobileEmitterEvents, PcEmitterEvents } from '@/helpers/emitter'
import { MessageInstance } from 'antd/es/message/interface'
import { PcLoginDecorator } from '@/helpers/decorator'
import { routerService } from '@/services/routerService'

class UiController {
  @observable message!: MessageInstance

  @observable test = false

  // 移动端购买弹窗
  @observable buyPopupProps: BuyPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.buyPopupProps.visible = false
      })
    },
  }

  // 移动端支付弹窗
  @observable payingPopupProps: PayingPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.payingPopupProps.visible = false
      })
    },
  }

  // 移动端支付成功弹窗
  @observable paySuccessPopupProps: PaySuccessPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.paySuccessPopupProps.visible = false
      })
    },
  }

  @action
  openPaySuccessPopup(download: boolean | (() => void) = false) {
    this.paySuccessPopupProps.visible = true
    this.paySuccessPopupProps.onDownload = download
  }

  // 移动端联系客服弹窗
  @observable contactPopupProps: ContactPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.contactPopupProps.visible = false
      })
    },
  }

  // 领取课件二维码
  @observable downloadConsultationQrCodePopupProps: ContactPopupProps = {
    visible: false,
    title: '领取课件',
    description: '添加客服领取课件～',
    onClose: () => {
      runInAction(() => {
        this.downloadConsultationQrCodePopupProps.visible = false
      })
    },
  }

  // 移动端登录弹窗
  @observable loginDialogProps: LoginDialogProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
    onLoginSuccess: () => {
      emitter.emit(MobileEmitterEvents.MOBILE_LOGIN_SUCCESS)
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
  }

  public init() {
    makeObservable(this)
    if ( commonUtils.isMobile()) {
      eruda.init()
    }
  }

  // PC端登录弹窗
  @observable PcLoginModalProps: LoginModalProps = {
    visible: false,
    type: 'login',
    onClose: () => {
      runInAction(() => {
        this.PcLoginModalProps.visible = false
      })
    },
    onLoginSuccess: () => {
      emitter.emit(PcEmitterEvents.PC_LOGIN_SUCCESS)
      runInAction(() => {
        this.PcLoginModalProps.visible = false
      })
    },
  }

  // PC端支付成功弹窗
  @observable PcPaySuccessModalProps: PaySuccessModalProps = {
    visible: false,
    goodsName: '',
    onDownload: function (): void {
      throw new Error('Function not implemented.')
    },
    onClose: () => {
      runInAction(() => {
        this.PcPaySuccessModalProps.visible = false
      })
    },
  }

  // PC 端支付弹窗
  @observable PcPayModalProps: PayModalProps = {
    visible: false,
    goodsDetail: undefined,
    onPaySuccess: function (goodsName: string): void {
      throw new Error('Function not implemented.')
    },
    onClose: () => {
      runInAction(() => {
        this.PcPayModalProps.visible = false
      })
    },
  }

  // PC 端下载弹窗
  @observable PcDownloadDialogProps: DownloadDialogProps = {
    visible: false,
    materials: [],
    goodsName: '',
    hasUnitChapter:false,
    total:0,
    onClose: () => {
      runInAction(() => {
        this.PcDownloadDialogProps.visible = false
        this.PcDownloadDialogProps.materials = []
        this.PcDownloadDialogProps.goodsName = ''
        this.PcDownloadDialogProps.hasUnitChapter = false
        this.PcDownloadDialogProps.total = 0
      })
    },
  }

  //
  @PcLoginDecorator()
  opneJBAI() {
    routerService.navigateTo('pcJBAI')
  }
}

export const uiController = new UiController()
